import React from "react";

import SidebarSkeleton from "../SidebarSkeleton";
import PageTitleSkeleton from "../PageTitleSkeleton";
import TextBlockSkeleton from "../TextBlockSkeleton";
import HeaderSkeleton from "../HeaderSkeleton";

function FullPageSkeleton({ isHeader = false, srMessage, className=''}) {
  return (
    <div role="status" className={`full-page-skeleton ${className}`}>
      { srMessage && 
        <span className="sr-only">
          {srMessage}
        </span>
      }
      {isHeader && 
        <div className="page-header-skeleton">
          <HeaderSkeleton />
        </div>
      }
      <div className="page-skeleton">
        <SidebarSkeleton />
        <div className="page-skeleton-content">
          <PageTitleSkeleton />
          <TextBlockSkeleton />
          <TextBlockSkeleton />
        </div>
      </div>
    </div>
  );
}

export default FullPageSkeleton;
